<template>
  <a-card class="cardMain"
          :tab-list="tabList"
          :active-tab-key="activeKey"
          @tabChange="(key: any) => onTabChange(key, 'key')">
    <template #customTab="item">
      <span v-if="item.key === 'role'">
        {{ item.tab }}
      </span>
    </template>
    <Role v-if="activeKey == 'role'"></Role>
    <User v-else-if="activeKey == 'user'"></User>
    <Position v-else-if="activeKey == 'position'"></Position>
    <organization v-else-if="activeKey == 'organization'"></organization>
  </a-card>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import organization from './RoleViewRightMenuOrganization.vue'
import Position from './RoleViewRightMenuPosition.vue'
import User from './RoleViewRightMenuUser.vue'
import Role from './RoleViewRightMenuRole.vue'
const activeKey = ref('role')

const tabList = reactive<Array<{ key: string, tab: string }>>([{
  key: 'role',
  tab: '权限',
}, {
  key: 'user',
  tab: '用户',
}, {
  key: 'organization',
  tab: '组织'
}, {
  key: 'position',
  tab: "职位"
}])

onMounted(() => {
  return
})
const onTabChange = (value: string, type: string) => {
  if (type === 'key') {
    activeKey.value = value
  }
}
</script>

<style lang="less" scoped>
</style>
